import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 ${theme.spacing.lg};
  width: 100%;

  @media (min-width: ${theme.breakpoints.md}) {
    padding: 0 ${theme.spacing.xl};
  }
`;